// auth.js
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'
export const SETPRELOADER_STATE = 'SETPRELOADER_STATE'
export const FETCH_EDIT_USER_DATA_SUCCESS = 'FETCH_EDIT_USER_DATA_SUCCESS'
export const FETCH_EDIT_USER_DATA_FAILURE = 'FETCH_EDIT_USER_DATA_FAILURE'
export const FETCH_STORAGE_SUCCESS = 'FETCH_STORAGE_SUCCESS'
export const FETCH_ARTICLES_SUCCESS = 'FETCH_ARTICLES_SUCCESS'
export const FETCH_EDIT_ARTICLE_SUCCESS = 'FETCH_EDIT_ARTICLE_SUCCESS'
export const FETCH_EDIT_ARICLE_CATEGORY_SUCCESS = 'FETCH_EDIT_ARICLE_CATEGORY_SUCCESS'
export const FETCH_ACTION_SUCCESS = 'FETCH_ACTION_SUCCESS'
export const FETCH_TEXTPAGE_FOOTER_SECTIONS_SUCCESS = 'FETCH_TEXTPAGE_FOOTER_SECTIONS_SUCCESS'
export const FETCH_TEXTPAGE_SUCCESS = 'FETCH_TEXTPAGE_SUCCESS'
